import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { FilterToggle, FilterToggleProps } from '../../../../components/filter';

interface SpecialPriceFilterProps extends Partial<FilterToggleProps> {
    isSpecialOffer: boolean;
}

export const SpecialPriceFilter = (props: SpecialPriceFilterProps): ReactElement => {
    const { isSpecialOffer, ...rest } = props;
    return (
        <FilterToggle
            sx={{ flex: 1 }}
            color="error"
            filterParam={FilterParams.SpecialPrice}
            label={<FormattedMessage id="app.filter.specialPrice" />}
            disabled={isSpecialOffer}
            {...rest}
        />
    );
};
